import { SET_PAGE_TITLE } from "./types";

export const setPageTitle = (payload) => ({ type: SET_PAGE_TITLE, payload });
